export default "__VITE_ASSET__d7cdc704__"